export default "__VITE_ASSET__685b160e__"